import axios from 'axios';
import {DqButton} from 'generated/JavaTOmodifications';
import {fetchDqAPI} from 'module/Dq/api/DqApi';

import {SharedAppState} from 'module/SharedAppState/type/SharedAppState'

export function fetchDqButtonsAPI() {
	return axios.get<DqButton[]>('../json/dqbuttons')
}

export function fetchDqButtonResultAPI(dqkey: string, params: SharedAppState) {
	return fetchDqAPI({dqkey, params})
}